export type {
  Alpha3Code,
  AuthMode,
  AuthOutcome,
  ForeignIdentityType,
  IdentificationAuthMode,
  IdentityType,
} from '@src/domains/customers/types/auth';
export { AUTH_MODE, AUTH_OUTCOME, FOREIGN_IDENTITY_TYPE, IDENTITY_TYPE } from '@src/domains/customers/types/auth';

export { canResendCode } from '@src/domains/customers/core/canResendCode';
export { isValidVerificationCode, VERIFICATION_CODE_LENGTH } from '@src/domains/customers/core/isValidVerificationCode';

export { resolveForeignIdentityType } from '@src/domains/customers/core/resolveForeignIdentityType';
export { resolveDialCode } from '@src/domains/customers/core/resolveDialCode';
export { BRAZIL_PHONE_DDI } from '@src/domains/customers/constants';
export { listDialCodes } from '@src/domains/customers/core/listDialCodes';
export type { DialCode } from '@src/domains/customers/core/listDialCodes';
export { isForeignSignupAllowed } from '@src/domains/customers/core/isForeignSignupAllowed';
export { isCnpjForeignConflict } from '@src/domains/customers/core/isCnpjForeignConflict';
export { isBuyerForeign } from '@src/domains/customers/core/isBuyerForeign';
export { resolveBuyerProfileVariant } from '@src/domains/customers/core/resolveBuyerProfileVariant';
export { BuyerProfileVariant } from '@src/domains/customers/core/resolveBuyerProfileVariant';
export { buildBuyerProfileFields } from '@src/domains/customers/core/buildBuyerProfileFields';
export { BuyerProfileFieldKind, BuyerDocumentKind } from '@src/domains/customers/core/buildBuyerProfileFields';
export type {
  BuyerProfileField,
  BuyerProfileFields,
  BuyerAccountType,
} from '@src/domains/customers/core/buildBuyerProfileFields';
export { resolveCountryDisplay } from '@src/domains/customers/core/resolveCountryDisplay';
export type { CountryDisplay } from '@src/domains/customers/core/resolveCountryDisplay';

export { meetsPasswordStrength, PASSWORD_MIN_LENGTH } from '@src/domains/customers/core/meetsPasswordStrength';
export { passwordsMatch } from '@src/domains/customers/core/passwordsMatch';

export { isValidBrazilianDocument } from '@src/domains/customers/core/isValidBrazilianDocument';
export { normalizeZipCode } from '@src/domains/customers/core/normalizeZipCode';
export { normalizeForeignPostalCode } from '@src/domains/customers/core/normalizeForeignPostalCode';
export { isValidZipCode, ZIP_CODE_LENGTH } from '@src/domains/customers/core/isValidZipCode';
export { buildForeignAddress } from '@src/domains/customers/core/buildForeignAddress';

export { normalizeIdentity } from '@src/domains/customers/core/normalizeIdentity';
export { resolveSubmittedIdentityType } from '@src/domains/customers/core/resolveSubmittedIdentityType';

export { decideAuthOutcome } from '@src/domains/customers/core/decideAuthOutcome';
export { isAuthComplete } from '@src/domains/customers/core/isAuthComplete';

export type { Address, EmailAvailability, SignupRequest, Buyer } from '@src/domains/customers/types/models';
